import {Component, OnInit} from '@angular/core';
import {FeatureSet} from "../../core/statistics-page-menu/statistics-page-menu.component";
import {environment} from "../../../environments/environment";
import {ProductKpiService} from "../services/product-kpi.service";
import {map} from "rxjs/operators";
import {ChartPeriod} from "../../core/timeline-selection/timeline-selection.component";
import {KPIS} from '../../core/kpi-modules';
import { of } from 'rxjs';


@Component({
  selector: 'cintas-avg-turnaround-time-detail',
  templateUrl: './avg-turnaround-time-detail.component.html',
  styleUrls: ['./avg-turnaround-time-detail.component.scss']
})
export class AvgTurnaroundTimeDetailComponent implements OnInit {

  features: FeatureSet = {
    //export: true,
    timeline: true
  };

  chartInfo = KPIS.avgTurnaroundTime.description;

  timeSelection: ChartPeriod = ChartPeriod.THIS_YEAR;

  view = environment.theme.baseView;
  colorScheme = environment.theme.colorPalette;

  avgTurnaroundTime$;

  constructor(private productService: ProductKpiService) {
  }

  ngOnInit() {
    this.onPeriodChanged(this.timeSelection);
  }

  onSelect(event) {
    console.log(event);
  }

  onPeriodChanged(period: ChartPeriod) {
    this.timeSelection = period;
    // this.avgTurnaroundTime$ = this.productService.getAvgTurnaroundTimePerProductType(this.timeSelection).pipe(
    //   map((res: any) => {
    //     let data: any[] = res.data;
    //     return data;
    //   })
    // );

    const mockData = {
      "Now": [
        { name: 'Sweat Jacket XL', avg_no_turnarounds: 22.3, value: 6.0 }, 
  { name: 'Sweat Jacket L', avg_no_turnarounds: 30.5, value: 7.8 },
  { name: 'Sweat Jacket M', avg_no_turnarounds: 20.8, value: 9.5 },
  { name: 'Sweat Jacket S', avg_no_turnarounds: 40.2, value: 5.7 },
  { name: 'Poloshirt XL', avg_no_turnarounds: 22.0, value: 4.5 },
  { name: 'Poloshirt L', avg_no_turnarounds: 43.0, value: 11.0 },
  { name: 'Poloshirt M', avg_no_turnarounds: 30.2, value: 9.0 },
  { name: 'Poloshirt S', avg_no_turnarounds: 22.5, value: 8.5 }
      ],
      "This week": [
        { name: 'Sweat Jacket XL', avg_no_turnarounds: 19.5, value: 5.2 }, 
  { name: 'Sweat Jacket L', avg_no_turnarounds: 32.6, value: 6.5 },
  { name: 'Sweat Jacket M', avg_no_turnarounds: 21.0, value: 10.2 },
  { name: 'Sweat Jacket S', avg_no_turnarounds: 39.0, value: 7.1 },
  { name: 'Poloshirt XL', avg_no_turnarounds: 21.9, value: 3.8 },
  { name: 'Poloshirt L', avg_no_turnarounds: 41.5, value: 10.8 },
  { name: 'Poloshirt M', avg_no_turnarounds: 30.8, value: 8.2 },
  { name: 'Poloshirt S', avg_no_turnarounds: 20.1, value: 9.4 }
      ],
      "This month": [
        { name: 'Sweat Jacket XL', avg_no_turnarounds: 23.0, value: 5.9 }, 
  { name: 'Sweat Jacket L', avg_no_turnarounds: 29.0, value: 7.5 },
  { name: 'Sweat Jacket M', avg_no_turnarounds: 22.2, value: 10.4 },
  { name: 'Sweat Jacket S', avg_no_turnarounds: 38.7, value: 6.0 },
  { name: 'Poloshirt XL', avg_no_turnarounds: 21.0, value: 4.2 },
  { name: 'Poloshirt L', avg_no_turnarounds: 44.2, value: 9.6 },
  { name: 'Poloshirt M', avg_no_turnarounds: 32.1, value: 8.9 },
  { name: 'Poloshirt S', avg_no_turnarounds: 21.4, value: 8.3 }
      ],
      "Last month": [
        { name: 'Sweat Jacket XL', avg_no_turnarounds: 20.0, value: 5.0 }, 
  { name: 'Sweat Jacket L', avg_no_turnarounds: 33.8, value: 6.8 },
  { name: 'Sweat Jacket M', avg_no_turnarounds: 20.5, value: 9.8 },
  { name: 'Sweat Jacket S', avg_no_turnarounds: 41.3, value: 6.6 },
  { name: 'Poloshirt XL', avg_no_turnarounds: 22.1, value: 4.8 },
  { name: 'Poloshirt L', avg_no_turnarounds: 42.5, value: 10.1 },
  { name: 'Poloshirt M', avg_no_turnarounds: 31.5, value: 8.6 },
  { name: 'Poloshirt S', avg_no_turnarounds: 21.3, value: 8.9 }
      ],
      "This year": [
        { name: 'Sweat Jacket XL', avg_no_turnarounds: 21.5, value: 5.5 }, 
      { name: 'Sweat Jacket L', avg_no_turnarounds: 31.8, value: 7.2 },
      { name: 'Sweat Jacket M', avg_no_turnarounds: 21.2, value: 10.0 },
      { name: 'Sweat Jacket S', avg_no_turnarounds: 41.6, value: 6.3 },
      { name: 'Poloshirt XL', avg_no_turnarounds: 21.4, value: 4.0 },
      { name: 'Poloshirt L', avg_no_turnarounds: 42.1, value: 10.4 },
      { name: 'Poloshirt M', avg_no_turnarounds: 31.9, value: 8.8 },
      { name: 'Poloshirt S', avg_no_turnarounds: 21.7, value: 9.1 }
      ],
      "Last year": [
        { name: 'Sweat Jacket XL', avg_no_turnarounds: 22.8, value: 6.1 }, 
        { name: 'Sweat Jacket L', avg_no_turnarounds: 31.1, value: 7.6 },
        { name: 'Sweat Jacket M', avg_no_turnarounds: 21.8, value: 10.3 },
        { name: 'Sweat Jacket S', avg_no_turnarounds: 40.4, value: 5.9 },
        { name: 'Poloshirt XL', avg_no_turnarounds: 21.6, value: 4.1 },
        { name: 'Poloshirt L', avg_no_turnarounds: 41.8, value: 10.5 },
        { name: 'Poloshirt M', avg_no_turnarounds: 32.5, value: 8.7 },
        { name: 'Poloshirt S', avg_no_turnarounds: 21.2, value: 9.0 }
      ],
      "Since 1 week": [
        { name: 'Sweat Jacket XL', avg_no_turnarounds: 21.1, value: 5.4 }, 
  { name: 'Sweat Jacket L', avg_no_turnarounds: 30.9, value: 7.4 },
  { name: 'Sweat Jacket M', avg_no_turnarounds: 20.6, value: 9.6 },
  { name: 'Sweat Jacket S', avg_no_turnarounds: 42.2, value: 6.2 },
  { name: 'Poloshirt XL', avg_no_turnarounds: 22.6, value: 4.3 },
  { name: 'Poloshirt L', avg_no_turnarounds: 40.9, value: 10.9 },
  { name: 'Poloshirt M', avg_no_turnarounds: 31.3, value: 8.4 },
  { name: 'Poloshirt S', avg_no_turnarounds: 21.8, value: 9.2 }
      ],
      "Since 2 week": [
        { name: 'Sweat Jacket XL', avg_no_turnarounds: 20.7, value: 5.6 }, 
  { name: 'Sweat Jacket L', avg_no_turnarounds: 32.4, value: 6.9 },
  { name: 'Sweat Jacket M', avg_no_turnarounds: 21.3, value: 10.1 },
  { name: 'Sweat Jacket S', avg_no_turnarounds: 40.8, value: 6.4 },
  { name: 'Poloshirt XL', avg_no_turnarounds: 21.5, value: 4.6 },
  { name: 'Poloshirt L', avg_no_turnarounds: 42.7, value: 10.3 },
  { name: 'Poloshirt M', avg_no_turnarounds: 31.0, value: 9.5 },
  { name: 'Poloshirt S', avg_no_turnarounds: 22.4, value: 9.3 }
      ],
      "Since 1 month": [
        { name: 'Sweat Jacket XL', avg_no_turnarounds: 21.9, value: 6.2 }, 
        { name: 'Sweat Jacket L', avg_no_turnarounds: 30.1, value: 7.9 },
        { name: 'Sweat Jacket M', avg_no_turnarounds: 22.4, value: 9.7 },
        { name: 'Sweat Jacket S', avg_no_turnarounds: 39.6, value: 6.5 },
        { name: 'Poloshirt XL', avg_no_turnarounds: 21.2, value: 4.9 },
        { name: 'Poloshirt L', avg_no_turnarounds: 43.5, value: 11.2 },
        { name: 'Poloshirt M', avg_no_turnarounds: 30.6, value: 8.0 },
        { name: 'Poloshirt S', avg_no_turnarounds: 21.0, value: 8.8 }
      ],
      "Since 3 months": [
        { name: 'Sweat Jacket XL', avg_no_turnarounds: 19.8, value: 5.3 }, 
  { name: 'Sweat Jacket L', avg_no_turnarounds: 32.9, value: 7.1 },
  { name: 'Sweat Jacket M', avg_no_turnarounds: 21.5, value: 10.6 },
  { name: 'Sweat Jacket S', avg_no_turnarounds: 40.1, value: 5.8 },
  { name: 'Poloshirt XL', avg_no_turnarounds: 22.3, value: 4.4 },
  { name: 'Poloshirt L', avg_no_turnarounds: 41.2, value: 10.0 },
  { name: 'Poloshirt M', avg_no_turnarounds: 31.7, value: 9.4 },
  { name: 'Poloshirt S', avg_no_turnarounds: 20.6, value: 8.7 }
      ],
      "Since 1 year": [
        { name: 'Sweat Jacket XL', avg_no_turnarounds: 20.3, value: 5.8 }, 
        { name: 'Sweat Jacket L', avg_no_turnarounds: 31.4, value: 7.3 },
        { name: 'Sweat Jacket M', avg_no_turnarounds: 20.9, value: 10.5 },
        { name: 'Sweat Jacket S', avg_no_turnarounds: 41.8, value: 6.7 },
        { name: 'Poloshirt XL', avg_no_turnarounds: 21.8, value: 4.7 },
        { name: 'Poloshirt L', avg_no_turnarounds: 42.0, value: 10.7 },
        { name: 'Poloshirt M', avg_no_turnarounds: 30.4, value: 8.3 },
        { name: 'Poloshirt S', avg_no_turnarounds: 21.5, value: 9.6 }
      ]
    




  

    // "5": [
    //   { name: "Jacket L", value: 2, no_lost_items_30: 1, no_lost_items_60: 1, no_lost_items_90: 2 },
    //   { name: "Shirt M", value: 3, no_lost_items_30: 0, no_lost_items_60: 1, no_lost_items_90: 2 }
    // ]
    // ,

    // "6": [
    //   { name: "Jacket L", value: 2, no_lost_items_30: 1, no_lost_items_60: 1, no_lost_items_90: 2 },
    //   { name: "Shirt M", value: 3, no_lost_items_30: 0, no_lost_items_60: 1, no_lost_items_90: 2 }
    // ]
  };

  const data = mockData[period] || [];
  this.avgTurnaroundTime$ = of(data)
  // this.avgTurnaroundTime$.subscribe(
  //   data => {
  //     console.log(data)
  //     this.unauthorizedAccessData = data; 
  //   },
  // );
  // console.log(this.avgTurnaroundTime$)
  // return of({ data });
  //   this.avgTurnaroundTime$ = of([
      // { name: 'Sweat Jacket XL', avg_no_turnarounds: 21.5, value: 5.5 }, 
      // { name: 'Sweat Jacket L', avg_no_turnarounds: 31.8, value: 7.2 },
      // { name: 'Sweat Jacket M', avg_no_turnarounds: 21.2, value: 10.0 },
      // { name: 'Sweat Jacket S', avg_no_turnarounds: 41.6, value: 6.3 },
      // { name: 'Poloshirt XL', avg_no_turnarounds: 21.4, value: 4.0 },
      // { name: 'Poloshirt L', avg_no_turnarounds: 42.1, value: 10.4 },
      // { name: 'Poloshirt M', avg_no_turnarounds: 31.9, value: 8.8 },
      // { name: 'Poloshirt S', avg_no_turnarounds: 21.7, value: 9.1 }
  //   ]);
    
  }

}
